module.exports = __webpack_public_path__ + "1381a16374c9ed803d7ccea99f2f8674.png";